import { cn } from "~/lib/utils";
import { BlogPost } from "~/modules/blog/api/sanity";

// // // //

/**
 * CategoryBadge
 * Renders a blog post's category as a colored pill. The background color is
 * data-driven (set per-category in Sanity), so it's applied via inline style;
 * everything else uses standard tokens to match the app's Badge styling.
 */
export function CategoryBadge(props: {
    post: Pick<BlogPost, "category" | "categoryColor" | "categoryLabel">;
    className?: string;
}) {
    const { post, className } = props;

    if (!post.category || !post.categoryLabel) {
        return null;
    }

    return (
        <span
            className={cn(
                "inline-flex items-center rounded-full px-3 py-0.5 text-sm font-semibold uppercase leading-6 tracking-[0.08em] text-foreground",
                className,
            )}
            style={{ backgroundColor: post.categoryColor }}
        >
            {post.categoryLabel}
        </span>
    );
}
